export default __webpack_public_path__ + "static/media/MZ.bd591a03.svg";